



import CarpsaleHistoryChatPdfComponent from "@/components/admin/carpsaleHistory/carpsaleHistoryChatPdfComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CarpsaleHistoryChatPdfPage",
  components: {
    CarpsaleHistoryChatPdfComponent,
  },
})
export default class CarpsaleHistoryChatPdfPage extends Vue {}
